import { MayBeNull, AttachmentMetadataResponse, AttachmentMetadata } from '@wpp-open/core'

export interface MarketForm {
  name: string
  isoAlpha2: string
  isoAlpha3: string
  logoThumbnail: MayBeNull<AttachmentMetadataResponse>
  logoOriginal: MayBeNull<AttachmentMetadataResponse>
  regionId: MayBeNull<string>
}

export interface MarketFormDTO {
  name: string
  isoAlpha2: string
  isoAlpha3: string
  logoThumbnail: MayBeNull<AttachmentMetadata>
  logoOriginal: MayBeNull<AttachmentMetadata>
}

export interface Market {
  id: string
  name: string
  isoAlpha2: string
  isoAlpha3: string
  logoThumbnail: MayBeNull<AttachmentMetadataResponse>
  logoOriginal: MayBeNull<AttachmentMetadataResponse>
  createdAt: string
  updatedAt: MayBeNull<string>
  deletedAt: MayBeNull<string>
  aliases: string[]
}

export enum MarketType {
  COUNTRY = 'COUNTRY',
  STATE = 'STATE',
  CITY = 'CITY',
}
